import { render, staticRenderFns } from "./ViewTemplate.vue?vue&type=template&id=181592fe&scoped=true"
import script from "./ViewTemplate.vue?vue&type=script&lang=js"
export * from "./ViewTemplate.vue?vue&type=script&lang=js"
import style0 from "./ViewTemplate.vue?vue&type=style&index=0&id=181592fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "181592fe",
  null
  
)

export default component.exports